import type { TenantMetadata } from '../types/tenant-metadata.types.ts';

const REQUIRED_METADATA_KEYS = [
	'id',
	'name',
	'branding',
	'pages',
	'integrations',
	'feature_flags',
	'featureBadges',
	'creator_settings',
	'portal_settings',
	'legal_links'
] as const;

function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === 'object' && value !== null;
}

export function assertTenantMetadata(
	value: unknown,
	partnerIdn: string,
	source: string
): asserts value is TenantMetadata {
	if (!isRecord(value)) {
		throw new Error(
			`Failed to load tenant metadata for "${partnerIdn}": ${source} is not an object.`
		);
	}

	for (const key of REQUIRED_METADATA_KEYS) {
		if (!(key in value)) {
			throw new Error(
				`Failed to load tenant metadata for "${partnerIdn}": ${source} is missing required field "${key}".`
			);
		}
	}

	if (!isRecord(value.pages)) {
		throw new Error(
			`Failed to load tenant metadata for "${partnerIdn}": ${source} field "pages" must be an object.`
		);
	}
}
